import { SelectItem } from "primeng/api";

enum AutoApproveType {
    NoWalkInCreated = 1,
    CreateNewPatientAwaitingApprovalOnWalkIn,
    CreateCompletedWalkIn
}

const AutoApproveTypeMap: Record<AutoApproveType, string> = {
    1: "No Walk In Created",
    2: "Create New Patient Awaiting Approval on Walk In",
    3: "Create Completed Walk In"
};

function createOptions() {
    return Object.keys(AutoApproveTypeMap)
        .map(k => +k as AutoApproveType)
        .map(k => <SelectItem>{ value: k, label: AutoApproveTypeMap[k] });
}

export { AutoApproveType, AutoApproveTypeMap, createOptions };
